import { useContent } from '../ContentContext';
import { PageHero, SectionHead } from '../components/Common';

export default function Infrastructure() {
  const { infrastructure = {} } = useContent();
  const {
    image, tag, title, paragraphs = [], facilities = [], highlights = [],
  } = infrastructure;

  return (
    <>
      <PageHero title="Infrastructure" image={image} />

      {/* Intro — 50/50 image + copy */}
      <section>
        <div className="container profile-grid">
          <div className="profile-image">
            <img src={image} alt={title} />
          </div>
          <div className="profile-content">
            {tag ? <span className="section-tag">{tag}</span> : null}
            <h2>{title}</h2>
            {paragraphs.map((p) => <p key={p}>{p}</p>)}
          </div>
        </div>
      </section>

      {/* Our Facilities — 3-up white cards on the grey band */}
      {facilities.length ? (
        <section className="grey-bg">
          <div className="container">
            <SectionHead title="Our Facilities" />
            <div className="facility-grid">
              {facilities.map((f) => (
                <div className="facility-card" key={f.title}>
                  <i className={`fas ${f.icon}`} />
                  <h3>{f.title}</h3>
                  <p>{f.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : null}

      {/* Infrastructure Highlights — maroon tiles */}
      {highlights.length ? (
        <section>
          <div className="container">
            <SectionHead title="Infrastructure Highlights" />
            <div className="highlight-grid">
              {highlights.map((h) => (
                <div className="highlight-item" key={h.title}>
                  <i className={`fas ${h.icon}`} />
                  <h3>{h.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}
